import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useKilnDrillingSettingsQueryParams {
  plantUpmId: string
  kilnUpmId: string
  date?: string
}

export const useKilnMaterialInstallationsQuery = ({
  plantUpmId,
  kilnUpmId,
  date
}: useKilnDrillingSettingsQueryParams) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'kilnMaterialInstallations',
    params: [{plantUpmId, kilnUpmId, date}],
    retry: false,
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useKilnMaterialInstallationsQuery')
        .extras({errorDetails, plantUpmId, kilnUpmId, date})
        .error('Error occurred while fetching kiln drilling settings')

      spawnErrorToast(t('error.kilnMaterialInstallationsQuery'))

      return false
    }
  })
}
